export function timeAgo(ts: number): string {
  if (!ts) {
    return "never";
  }
  const seconds = Math.max(0, Math.floor((Date.now() - ts) / 1000));
  if (seconds < 60) {
    return `${seconds}s ago`;
  }
  if (seconds < 3600) {
    return `${Math.floor(seconds / 60)}m ago`;
  }
  if (seconds < 86_400) {
    return `${Math.floor(seconds / 3600)}h ago`;
  }
  return `${Math.floor(seconds / 86_400)}d ago`;
}

export function formatTimestamp(ts: number): string {
  const date = new Date(ts);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
}

export function detectLanguage(value: string): string {
  const trimmed = value.trimStart();
  if (trimmed.startsWith("{") || trimmed.startsWith("[")) {
    return "json";
  }
  if (trimmed.startsWith("<")) {
    return "xml";
  }
  if (trimmed.includes("\n") && /^[\w.[\]-]+\s*=/m.test(trimmed)) {
    return "properties";
  }
  if (trimmed.includes("\n") && /^[\w.-]+\s*:\s/m.test(trimmed)) {
    return "yaml";
  }
  return "text";
}

export const EDITOR_LANGUAGES = ["text", "json", "yaml", "xml", "properties", "html", "css", "lua"];
